/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_Category_PlaceholderInputs */

const en_admin_posts_category_placeholder = /** @type {(inputs: Admin_Posts_Category_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select category`)
};

const zh_admin_posts_category_placeholder = /** @type {(inputs: Admin_Posts_Category_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择分类`)
};

/**
* | output |
* | --- |
* | "Select category" |
*
* @param {Admin_Posts_Category_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_posts_category_placeholder = /** @type {((inputs?: Admin_Posts_Category_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_Category_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_posts_category_placeholder(inputs)
	return zh_admin_posts_category_placeholder(inputs)
});
export { admin_posts_category_placeholder as "admin.posts.category_placeholder" }